import { create } from "zustand";
import { STEP } from "../../components/Characters/AddCharacterDialog/constant";
import {
  createNew,
  deleteCharacter,
  update,
} from "../../ApiServices/Characters";
import toast from "react-hot-toast";
import { checkSuccessStatus } from "../../ApiServices/handleErrors";
import { API } from "../../ApiServices/apis";
import api from "../../composables/app";
import useUserDetailsStore from "../UserStore";

const characterStore = create((set, get) => ({
  activeView: STEP.SELECT_CHARACTER_TYPE,
  setActiveView: (view) => {
    set({ activeView: view });
  },
  characters: [],
  setCharacters: (characters) => {
    set({ characters });
  },
  selectedCharacters: [],
  setSelectedCharacters: (characters) => {
    set({ selectedCharacters: characters });
  },
  selectedCharacterIds: [],
  setSelectedCharacterIds: (ids) => {
    set({ selectedCharacterIds: ids });
  },
  deleteCharacterId: null,
  setDeleteCharacterId: (id) => {
    set({ deleteCharacterId: id });
  },
  closeDeleteCharacterDialog: () => {
    set({ deleteCharacterId: null });
  },
  selectedCharacterForEdit: null,
  setSelectedCharacterForEdit: (character) => {
    set({
      selectedCharacterForEdit: character,
      activeView: STEP.ADD_CHARACTER,
    });
  },
  isAddCharacterVisible: false,
  setIsAddCharacterVisible: (value) => {
    set({ isAddCharacterVisible: value });
  },
  characterUpdating: false,
  createNewCharacter: (data, callback) => {
    set({ characterUpdating: true });
    createNew(data)
      .then((res) => {
        if (checkSuccessStatus(res)) {
          //add new added character to the list
          set((state) => ({
            characters: [res.data.data.character, ...state.characters],
          }));
          useUserDetailsStore
            .getState()
            .updateCanAddCharacter(res.data.data.can_add_character);
          toast.success(
            "Character created successfully! Please wait we are creating awesome character for you."
          );
        }
        callback();
      })
      .finally(() => {
        set({ characterUpdating: false });
      });
  },
  updateCharacter: (id, data, callback) => {
    set({ characterUpdating: true });

    update(id, data)
      .then((res) => {
        if (checkSuccessStatus(res)) {
          //find and update the character
          set((state) => ({
            characters: state.characters.map((character) => {
              if (character.id === id) {
                return res.data.data.character;
              }
              return character;
            }),
          }));
          toast.success(
            res.data["status-message"] || "Character created successfully"
          );
        }
        callback();
      })
      .finally(() => {
        set({ characterUpdating: false });
      });
  },

  selectedKidForCharacter: null,
  setSelectedKidForCharacter: (kid) => {
    set({ selectedKidForCharacter: kid });
  },
  humanData: null,
  getHumanData: async () => {
    try {
      const url = `${API.story.getChildDetails}/${
        get().selectedKidForCharacter.id
      }`;
      const response = await api.get(url);
      set({ humanData: response?.data?.data });
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  },
  setHumanData: (data) => {
    set({ humanData: data });
  },
  updateHumanImagePredictionPendingStatus: (status) => {
    const humanData = get().humanData;
    const updatedData = { ...humanData, is_prediction_pending: status };
    if (humanData) {
      set({ humanData: updatedData });
    }
  },
  updateCharacterAvatar: ({ character_id, image_url }) => {
    set((state) => ({
      characters: state.characters.map((character) => {
        if (character.id === character_id) {
          return {
            ...character,
            avatar_url: image_url ? image_url : character.avatar_url,
            is_generation_pending: false,
          };
        }
        return character;
      }),
    }));
  },
  deleteCharacter: (id) => {
    deleteCharacter(id).then((res) => {
      if (checkSuccessStatus(res)) {
        set((state) => ({
          characters: state.characters.filter(
            (character) => character.id !== id
          ),
        }));
        toast.success("Character deleted successfully");
      }
    });
  },
}));
export default characterStore;
